import { isMobile, isTablet } from 'react-device-detect';

var mult = isMobile || isTablet ? 2 : 1;

export const WildItem = {
	name: 'WildItem',
	position: {
		x: 0,
		y: 0
	},
	components: [
		{
			name: 'frame',
			type: 'AnimatedSprite',
			position: { x: -5, y: 5 },
			animation: {
				pattern: 'Wildflames_000$.png',
				start: 0,
				end: 34,
				speed: 0.5,
				precision: 2,
				loop: true,
				scale: {
					x: 0.85 * mult,
					y: 0.85 * mult
				}
			}
		},
		{
			name: 'wild',
			type: 'AnimatedSprite',
			position: { x: 0, y: 0 },
			animation: {
				pattern: 'Blaster$.png',
				start: 0,
				end: 58,
				speed: 0.5,
				precision: 2,
				loop: true,
				scale: {
					x: 1 * mult,
					y: 1 * mult
				}
			}
		},
		{
			name: 'text',
			//type: "AnimatedSprite",
			position: { x: 36, y: 170 },
			type: 'Sprite',
			img: 'reel_wild_text_x5',
			scale: {
				x: 0.9 * mult,
				y: 0.9 * mult
			}
		}
	]
};
